import './style.scss';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import 'swiper/css';

// スライド表示に切り替えるブレイクポイント（common/_variable.scss の mq(tablet) と揃える）
const SP_MEDIA_QUERY = '(max-width: 767px)';

document.addEventListener('DOMContentLoaded', function() {
    const calendars = document.querySelectorAll('.kjb-seasonality-calendar[data-sp-layout="slider"]');

    if (!calendars.length) {
        return;
    }

    const mediaQuery = window.matchMedia(SP_MEDIA_QUERY);

    calendars.forEach((calendar) => {
        const viewport = calendar.querySelector('.kjb-seasonality-calendar__viewport');
        const pagination = calendar.querySelector('.kjb-seasonality-calendar__pagination');

        if (!viewport) {
            return;
        }

        let swiper = null;

        // スマホ幅のときだけSwiperを有効化し、PC幅では破棄してグリッド表示に戻す
        const updateSwiper = () => {
            if (mediaQuery.matches && !swiper) {
                swiper = new Swiper(viewport, {
                    modules: [Pagination],
                    slidesPerView: 1.12,
                    spaceBetween: 12,
                    watchOverflow: true,
                    pagination: pagination ? {
                        el: pagination,
                        clickable: true,
                    } : false,
                });
            } else if (!mediaQuery.matches && swiper) {
                swiper.destroy(true, true);
                swiper = null;
            }
        };

        updateSwiper();

        if (typeof mediaQuery.addEventListener === 'function') {
            mediaQuery.addEventListener('change', updateSwiper);
        } else {
            mediaQuery.addListener(updateSwiper);
        }
    });
});
